import React, { memo } from "react";
import Avatar from "../../avatar";

const DirectConversationItem = ({
	name,
	preview,
	lastUpdate,
	photoUrl,
	unreadCount = 0,
	extraClass = "",
	dimension = "thumb6",
	conversationId,
}: {
	name: string;
	preview: string;
	lastUpdate: string;
	photoUrl: string;
	unreadCount?: Number;
	extraClass?: string;
	dimension?: string;
	conversationId: string;
}) => (
	<div className={`item conversation medium ${extraClass} ${unreadCount > 0 ? "unread" : ""}`} id={conversationId}>
		{photoUrl ? (
			<div className="itemImage">
				<Avatar photoUrl={photoUrl} size={dimension} />
			</div>
		) : null}
		<div className="itemBody">
			<div className="combinedLabels">
				<div className="title">
					<div className="longTextWrap">
						<div className="longText">
							{name} {unreadCount ? `(${unreadCount})` : ""}
						</div>
					</div>
				</div>
				<div className="time">{lastUpdate}</div>
			</div>
			<div className="meta">
				{preview ? (
					<div className="longTextWrap">
						<div className="longText">{preview}</div>
					</div>
				) : null}
			</div>
		</div>
	</div>
);

export default memo(DirectConversationItem);
